import SkeletonShippinGroupDetail from "components/Commons/Skeleton/SkeletonShippinGroupDetail"
import SummaryProductList from "components/Contractor/OrderDetail/SummaryProducts/SummaryProductsList"
import { AuthContext } from "context/context/AuthContext"
import OrderDetailHOC from "hoc/OrderDetailHOC"
import { Suspense, useContext, useMemo } from "react"
import { OrderDetailType } from "types/OrderType"
import { clients } from "webapp-clients/Clients"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { GlobalContext } from "context/context/GlobalContext"

const ContractorInstallationCompleteScreen = ({ shippinGroupDetail, shippingGroupId, order }: OrderDetailType) => {
  const { errorHander } = useContext(GlobalContext)

  const {
    state: { user },
  } = useContext(AuthContext)

  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const ContentFileMedia = client["ContentFileMedia" as keyof typeof client]

  const files = shippinGroupDetail?.status
    .filter(({ media }) => media)
    .flatMap(({ media }) => media?.ref.map(({ id }) => id))

  const itemsOrder = useMemo(() => {
    const sourceItems = shippinGroupDetail?.source?.items || []
    const orderItems = order?.items || []

    // Crear un mapa para búsqueda eficiente O(1)
    const supplierCodeMap = new Map<string, string>()

    orderItems.forEach((orderItem: any) => {
      if (orderItem?.sku && orderItem?.custom?.supplierCode) {
        supplierCodeMap.set(orderItem.sku, orderItem.custom.supplierCode)
      }
    })

    // Mapear sourceItems agregando el supplierCode donde haya coincidencia
    return sourceItems.map((item) => {
      const supplierCode = supplierCodeMap.get(item.sku)
      if (supplierCode) {
        return {
          ...item,
          supplierCode,
          custom: {
            ...item.custom,
            supplierCode
          }
        }
      }
      return item
    })
  }, [shippinGroupDetail?.source?.items, order?.items])

  return (
    <>
      {errorHander?.state?.hasError ? (
        <ErrorHandler
          code={errorHander.state.code}
          message={errorHander.state.message || "Ha ocurrido un error inesperado"}
        />
      ) : itemsOrder ? (
        <>
          <SummaryProductList
            itemsOrder={itemsOrder}
            groupPicking={false}
            titleMain={"Productos entregados"}
          />

          {ContentFileMedia && files && files.length > 0 && (
            <Suspense fallback={null}>
              <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                <ContentFileMedia listIdFiles={files} shippingGroupId={shippingGroupId} documents={undefined} />
              </div>

            </Suspense>
          )}
        </>
      ) : (
        <SkeletonShippinGroupDetail />
      )}
    </>
  )
}

export default OrderDetailHOC(ContractorInstallationCompleteScreen)
